import { ReactElement } from 'react';
import { Modal } from '@components/common/modal/modal';
import { AidModal } from '@components/contractor360KAE/components/aidModal/aidModal';
import { IContractorAidModalsProps } from '.';

export const ContractorAidModals = ({
	showCarpenterModal,
	userId,
	isAIDOpen,
	isNoOfCarpenterOpen,
	closeAIDModal,
	closeCarpenterModal,
	refetch,
}: IContractorAidModalsProps): ReactElement => {
	return (
		<>
			<Modal
				modalTitle="Contractor AID"
				modalOpen={isAIDOpen}
				modalId="contractorAID"
				isEscAllow={false}
				className="dialog-lg dialog-bottom dialog-conform"
			>
				<AidModal
					type="aid"
					userId={userId}
					closeModal={() => {
						closeAIDModal();
						refetch?.();
					}}
				/>
			</Modal>

			{showCarpenterModal && (
				<Modal
					modalTitle="Contractor No. of carpenters"
					modalOpen={isNoOfCarpenterOpen}
					modalId="contractorCarpenters"
					isEscAllow={false}
					className="dialog-lg dialog-bottom dialog-conform"
				>
					<AidModal
						type="carpenter"
						userId={userId}
						closeModal={() => {
							closeCarpenterModal();
							refetch?.();
						}}
					/>
				</Modal>
			)}
		</>
	);
};
